import React from "react";
import InvoicesPrint from "../AFReadyDisigen/InvoicesPrint";
export default function EnglishInv(props) {
    return (
        <div>
            <InvoicesPrint  typeInv={6} />
        </div>
    );
}